import React, { useState } from 'react'
import fb from '../../assets/img/fb.png'
import insta from '../../assets/img/insta.png'
import x from '../../assets/img/x.png'
const TeamSection = ({ teams, title }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedTeamMember, setSelectedTeamMember] = useState(null)

  const callModal = member => {
    setSelectedTeamMember(member)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedTeamMember(null)
  }

  return (
    <div>
      <section
        id='about'
        className='bg-white about-screen rounded-xl flex flex-col justify-between items-center mobile:flex-col mobile:max-h-full tablet:max-h-full about-screen'
      >
        <div
          className={`flex flex-col items-center justify-center ${
            teams.length === 2 ? 'mt-[-20px]' : 'mt-8'
          } mobile:mt-2 `}
        >
          <div
            className={`grid gap-12 mobile:gap-0 tablet:gap-10 mobile:grid-cols-1 temp:gap-0 tablet:grid-cols-2 ${
              teams.length === 5 ? 'grid-cols-4' : 'grid-cols-3 '
            }`}
          >
            {teams.map((item, index) => (
              <div
                key={index}
                onClick={() => callModal(item)}
                className='mobile:mt-0 tablet:mt-0 cursor-pointer'
              >
                <div
                  className='flex flex-col items-center text-center p-4  rounded-lg 
                mobile:w-full max-w-[280px] tablet:max-w-[420px] mobile:max-w-full '
                >
                  <img
                    src={item.photo}
                    alt={item.name}
                    className=' object-cover h-[220px] rounded-lg mobile:h-[420px] tablet:h-[420px]'
                  />
                  <p className='font-semibold text-[18px] mt-4 mb-2 mobile:text-[20px]'>
                    {item.name}
                  </p>
                  <p className='text-[14px] text-[#215998] font-semibold  mobile:text-[16px]  max-w-[320px]'>
                    {item.job}
                  </p>
                  <p className='text-[12px] text-[#475467] font-normal  mobile:text-[16px]  mobile:max-w-full max-w-[320px]'>
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Modal */}
      {isModalOpen && (
        <div
          className='fixed inset-0 z-50 flex items-center justify-end bg-black bg-opacity-50'
          onClick={closeModal}
        >
          <div
            className='w-[592px] h-full bg-white p-6 flex flex-col shadow-xl mobile:w-full'
            onClick={e => e.stopPropagation()}
          >
            <button
              className='absolute top-[40px] right-[30px] '
              onClick={closeModal}
            >
              <img
                src='https://icons.veryicon.com/png/o/miscellaneous/all-blue-icon/close-428.png'
                alt='Arrow Down'
                className='h-4 w-4'
                style={{ marginRight: 10 }}
              />
            </button>
            {selectedTeamMember && (
              <div
                className='mt-4 flex flex-col justify-start items-center h-[100vh] overflow-y-auto p-4'
                style={{
                  scrollbarWidth: 'thin',
                  scrollbarColor: ' #215998 #EBF4FF'
                }}
              >
                <img
                  src={selectedTeamMember.photo}
                  alt={selectedTeamMember.name}
                  className='h-48 object-cover rounded-lg'
                />
                <h2 className='text-xl font-bold mt-4'>
                  {selectedTeamMember.name}
                </h2>
                <p
                  style={{
                    fontSize: 18,
                    color: '#215998',
                    textAlign: 'center'
                  }}
                >
                  {selectedTeamMember.job}
                </p>
                <p
                  style={{
                    fontSize: 16,
                    color: '#475467',
                    textAlign: 'center'
                  }}
                >
                  {selectedTeamMember.title}
                </p>
                {selectedTeamMember.education && (
                  <p className='font-bold mt-4 text-start'>Боловсрол: </p>
                )}
                {selectedTeamMember.education && (
                  <ul className='list-disc pl-5  mt-2'>
                    {selectedTeamMember.education.map((treat, index) => (
                      <li
                        key={index}
                        className='mb-2 text-[1₮px] text-[#626578]'
                      >
                        {treat}
                      </li>
                    ))}
                  </ul>
                )}
                {selectedTeamMember.experiences && (
                  <p className='font-bold mt-4'>Ажлын туршлага: </p>
                )}
                {selectedTeamMember.experiences && (
                  <ul className='list-disc pl-5  mt-2'>
                    {selectedTeamMember.experiences.map((treat, index) => (
                      <li
                        key={index}
                        className='mb-2 text-[1₮px] text-[#626578]'
                      >
                        {treat}
                      </li>
                    ))}
                  </ul>
                )}
                {selectedTeamMember.partnership && (
                  <p className='font-bold mt-4'>Гишүүнчлэл: </p>
                )}
                {selectedTeamMember.partnership && (
                  <ul className='list-disc pl-5  mt-2'>
                    {selectedTeamMember.partnership.map((treat, index) => (
                      <li
                        key={index}
                        className='mb-2 text-[1₮px] text-[#626578]'
                      >
                        {treat}
                      </li>
                    ))}
                  </ul>
                )}
                <div className='flex flex-row justify-center items-center mt-4 gap-2 '>
                  <div className='h-7 w-7 border border-r-1 border-gray-200 rounded-md'>
                    {selectedTeamMember.fb && (
                      <img
                        src={fb}
                        onClick={() => window.open(`${selectedTeamMember.fb}`)}
                        className=' cursor-pointer'
                        alt='Facebook'
                      />
                    )}
                  </div>
                  {selectedTeamMember.x && (
                    <div className='h-7 w-7 border border-r-1 border-gray-200 rounded-md '>
                      <img
                        src={x}
                        alt='X'
                        className=' cursor-pointer'
                        onClick={() => window.open(`${selectedTeamMember.x}`)}
                      />
                    </div>
                  )}
                  {selectedTeamMember.insta && (
                    <div className='h-7 w-7 border border-r-1 border-gray-200 rounded-md'>
                      <img
                        src={insta}
                        alt='Instagram'
                        className=' cursor-pointer'
                        onClick={() =>
                          window.open(`${selectedTeamMember.insta}`)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default TeamSection
